import { Box, Typography } from "@mui/material";
import CustomCopyButton from "../../../../../../components/CustomCopyButton";
import TextIntegrationStyle from "../../TextIntegrationStyle";

const NotionAppDetailsView = ({ entityData }) => {
  const notionData = entityData?.notion_data || {};
  const ownerType = notionData.owner_type || "—";
  const botOwner = notionData.bot_owner || "—";
  const ownerDisplay = botOwner !== "—" ? `${ownerType} : ${botOwner}` : "-";

  return (
    <Box>
      <Box display="flex" flexDirection="column" gap={2}>
        {/* Bot Owner */}
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">App Owner</Typography>
          </Box>
          <Box ml={2}>
            <TextIntegrationStyle title="" value={ownerDisplay} />
          </Box>
        </Box>
        {/* Workspace Name */}
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display={"flex"} gap={1} alignItems={"center"}>
            <Typography variant={"subtitle2"}>Workspace Name</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            <TextIntegrationStyle
              title=""
              value={notionData.workspace_name || "—"}
            />

            {notionData.workspace_name && (
              <CustomCopyButton
                copyTitle="Workspace Name"
                copyText={notionData.workspace_name}
                width="16px"
              />
            )}
          </Box>
        </Box>
        {/* Workspace ID */}
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <Typography variant="subtitle2">Workspace ID</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            <TextIntegrationStyle
              title=""
              value={notionData.workspace_id || "—"}
            />
            {notionData.workspace_id && (
              <CustomCopyButton
                copyTitle="Workspace ID"
                copyText={notionData.workspace_id}
                width="16px"
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default NotionAppDetailsView;
